(function () {
    const header = document.getElementById('main-header');
    if (!header) return;

    const toggles = header.querySelectorAll('.nav-dropdown-toggle');
    if (!toggles.length) return;

    function closeAll(exceptToggle) {
        toggles.forEach(function (btn) {
            if (btn === exceptToggle) return;
            const li = btn.closest('li');
            if (li) li.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
        });
    }

    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function (event) {
            event.preventDefault();
            const li = toggle.closest('li');
            if (!li) return;

            const isOpen = toggle.getAttribute('aria-expanded') === 'true';
            closeAll(toggle);

            if (isOpen) {
                li.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
            } else {
                li.classList.add('is-open');
                toggle.setAttribute('aria-expanded', 'true');
            }
        });
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        const openToggle = Array.prototype.find.call(toggles, function (btn) {
            return btn.getAttribute('aria-expanded') === 'true';
        });
        if (!openToggle) return;
        closeAll(null);
        openToggle.focus();
    });

    document.addEventListener('click', function (event) {
        if (header.contains(event.target)) return;
        closeAll(null);
    });

    document.addEventListener('focusin', function (event) {
        toggles.forEach(function (btn) {
            if (btn.getAttribute('aria-expanded') !== 'true') return;
            const li = btn.closest('li');
            if (!li || li.contains(event.target)) return;
            li.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
        });
    });
})();
